import { OrderPaymentStatus, OrderStage, PaymentMethod, PaymentStatus, Proration } from "@/pages/billing/types";
import type { CRMNote } from "@/types";

export enum PayerType {
  SELF = "self",
  OTHER = "other",
  FACILITY = "facility"
}

export type PaymentType = {
  id: string;
  amountCents: number;
  refundedAmountCents: number;
  status: PaymentStatus;
  type: PaymentMethod;
  paidAt: string;
  transactionId: string;
  transactionUrl: string;
  stripeAccount: string;
  referenceNumber?: string;
  source: string;
  payer: {
    id: string;
    name: string;
    email: string;
    type: PayerType;
  };
  orderPayments: OrderPayment[];
  notes: CRMNote[];
  bypass: boolean;
};

export type OrderPayment = {
  id: string;
  amountCents: number;
  createdAt: string;
  type: string;
  order: Order;
  ledgerEntries: {
    amountCents: number;
    createdAt: string;
    type: string;
    lineItem: LineItem;
    secondaryLineItem: LineItem;
  }[];
  lineItems: LineItem[];
  lineItemsOriginal?: LineItem[];
  status: OrderStage;
  balanceCents: number;
};

export interface LineItem {
  id: string;
  name: string;
  totalPrice: number;
  priceCents: number;
  balance: number;
  proratable: boolean;
  proration: Proration;
}

export interface Order {
  id: string;
  eventRegistration: {
    id: string;
    event: {
      title: string;
      slug: string;
      startsAt: string;
      activityType: string;
    };
  } | null;
  person: {
    id: string;
    firstName: string;
    lastName: string;
    profilePhoto: string;
    pgaId: string;
    mainProgramType: {
      name: string;
    };
  };
  description: string;
  dueDate: string;
  balance: number;
  lineItems: LineItem[];
  lineItemsTotal: number;
  status: OrderStage;
  paymentStatus: OrderPaymentStatus;
}
export interface LineItem {
  id: string;
  name: string;
  quantity: number;
  priceCents: number;
  proration: Proration;
}
export interface CellProps {
  row: {
    original: Order;
  };
}
